import React from 'react';
import styles from './curso_studio_lorranycastro.module.scss';
import LorranyImage from './src/curso-imagem.png';
import Logo from './src/logo.png';
import { useEffect } from 'react';

const Curso_studio_lorranycastro: React.FC = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div className={styles.curso_studio_lorranycastro}>
            <div className={styles.cursoContainer}>
                <div className={styles.header}>
                    <img src={LorranyImage} className={styles.profileImage} alt="Lorrany Castro" />
                </div>
                <div className={styles.content}>
                    <img src={Logo} className={styles.logo} alt="Logo" />
                    <h1>Olá, futura lash designer!</h1>
                    <p>
                        Meu nome é Lorrany Castro, sou master e empreendedora. Atualmente, tenho 28 anos e atuo na área há pouco mais de quatro anos e meio.
                        Portanto, sou a pessoa certa, com experiência e propriedade, para fazer com que você se torne uma lash designer qualificada.
                    </p>
                    <p>
                        Neste curso, você será capaz de iniciar imediatamente no mercado de trabalho, com uma didática fácil e uma técnica de excelência.
                        Vou transferir todo o meu conhecimento, compartilhando tanto os erros quanto, principalmente, os acertos que me trouxeram até aqui.
                        Você aprenderá duas técnicas: <b>Volume Brasileiro</b> e <b>Volume Egípcio</b>.
                    </p>
                    <p>
                        Agora chegou a sua vez, futura lash designer! Este curso foi planejado para você, que deseja mudar de vida, assim como eu mudei a minha.
                        O primeiro passo você já deu!
                    </p>
                    <a
                        href="https://wa.me/5517991791926?text=Olá, tudo bem? Gostaria de mais informações sobre o curso"
                    >
                        <button className={styles.infoButton}>Gostaria de mais informações</button>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Curso_studio_lorranycastro;
